import { render } from "./DonateCard.vue?vue&type=template&id=1deefaa6&scoped=true&lang=pug"
import script from "./DonateCard.vue?vue&type=script&lang=js"
export * from "./DonateCard.vue?vue&type=script&lang=js"

import "./DonateCard.vue?vue&type=style&index=0&id=1deefaa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1deefaa6"]])

export default __exports__